import {Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validators
} from "@angular/forms";
import {SharedService} from "../../../../shared/shared.service";
import {CoreService} from "../../../../../services/core/core.service";
import {DialogService} from "../../../../../services/core/dialog.service";
import {pairwise, startWith} from "rxjs/operators";
import {Subscription} from "rxjs";

import { NotOnlySpaces } from '../../../../shared/CustomValidators/CustomNotOnlySpacesValidator';
import { EmailValidator } from '../../../../shared/CustomValidators/CustomInvalidEmailValidator';
import {WebsiteURLValidator} from '../../../../shared/CustomValidators/CustomWebsiteUrlValidator';
import {PhoneNumberValidator} from '../../../../shared/CustomValidators/CustomInvalidPhoneNumberValidator';
//import {FaxNumberValidator} from '../../../shared/CustomValidators/CustomInvalidFaxNumberValidator';

@Component({
    selector: 'app-subcontractor-add-form',
    templateUrl: './subcontractor-add-form.component.html',
    styleUrls: ['./subcontractor-add-form.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SubcontractorAddFormComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => SubcontractorAddFormComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SubcontractorAddFormComponent implements OnInit {

  @Input() model: any = {};
  @Input() form: any = {};
  @Input() isEdit: boolean = false;
  @Output() callback = new EventEmitter<any>(true);
  @Output() onInitForm = new EventEmitter<any>(true);
  //@ts-ignore
  public addSubcontractorFormSubscription: Subscription;

  public addSubcontractorForm: UntypedFormGroup = new UntypedFormGroup({

    name: new UntypedFormControl(null,[Validators.required,NotOnlySpaces()]),
    email: new UntypedFormControl(null,[EmailValidator() ]),
    phone: new UntypedFormControl(null,[PhoneNumberValidator()]),
    alternate_phone: new UntypedFormControl(null,[PhoneNumberValidator()]),

  });

  public offices: string[] = [];
  public subOffices: string[] = [];

  constructor(
    public sharedService: SharedService,
    public coreService: CoreService,
    public dialogService: DialogService
  ) { }


  ngOnChanges(changes: SimpleChanges) {
    this.model = changes?.model?.currentValue;
  }
  preventspace(event : KeyboardEvent){
    if(event.keyCode==32){
      event.preventDefault();
    }
  }

  ngOnInit(): void {
    this.initSubscriptions();
  }

  ngAfterViewInit(): void {
    this.setDataOnEdit();
  }

  setDataOnEdit = () => {
    if(this.isEdit) {
      this.addSubcontractorForm?.setValue({
        name: this.model?.name,
        email: this.model?.email,
        phone: this.model?.phone,
        alternate_phone: this.model?.alternate_phone
      });
    }
  }

  public onTouched: () => void = () => {};

  writeValue(val: any): void {
    val && this.addSubcontractorForm.setValue(val, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.addSubcontractorForm.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.addSubcontractorForm.disable() : this.addSubcontractorForm.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null{
    return this.addSubcontractorForm.valid ? null : { invalidForm: {valid: false, message: "Subcontractor fields are invalid"}};
  }

  initSubscriptions(){
    if (this.form){
      this.addSubcontractorFormSubscription = this.form.valueChanges
        .pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (this.form.touched){
            this.touchFormControls();
          }
        });
    }

  }
  touchFormControls(){
    Object.keys(this.addSubcontractorForm.controls).forEach(key => {
      this.addSubcontractorForm.get(key)?.markAsTouched();
    });
  }

  ngOnDestroy(){
    // prevent memory leak when component destroyed
    this.addSubcontractorFormSubscription?.unsubscribe();
  }

}
